function dobbleGameCell(conf,resources){
    conf=$.extend(true,{
        imgConf:{},
        
        radius:155,
        img_size_full:150,
        is_own:0,
        pos:[0,0],
        
        p_id:0,//it is a pointer
        
        set_id:1,//to calib
        arr_id:0,//to calib
        imgArr:[],//to calib
        zIndex:0,
        state:"own",
        v:12
    },conf);
    myPixiElement.container.call(this,{});
    this.conf=conf;
    this.resources=resources;
    this.imgConf=copyObj(this.conf.imgConf);
    //cell_back
    this.addChild(new myPixiElement.img({img:"cell_back"}));
    this.imgCointainer=new PIXI.Container();
    
    this.lineCointainer=new myPixiElement.container({});
    this.imgCointainer.addChild(this.lineCointainer);
    this.addChild(this.imgCointainer);
    this.mainCircle=new PIXI.Circle(0,0,this.conf.radius);
    this.polyIsSet=0;
    
    
    
    this.shapeArr={
        "mark":new PIXI.Graphics(),
        "wrong":new PIXI.Graphics(),
        "line":new PIXI.Container(),
        "line_circle":new myPixiElement.img({img:"mark_cell"})
    };
    
    this.markObj=new myPixiElement.img({img:"mark_cell_green"});
    this.markUn=new myPixiElement.img({img:"mark_cell_un"});
            
    
    this.wrongObj=new myPixiElement.img({img:"mark_wrong"});
    this.wrongObj.alpha=0;
    
    
    this.lineCointainer.addChild(this.shapeArr.line);
    this.lineCointainer.alpha=0;
    this.lineCointainer.addChild(this.shapeArr.line_circle);
//    this.shapeArr.line_circle.alpha=0.5;
    
    
    
    this.markObj.img_active=-1;
    this.markObj.alpha=0;
    this.markObj.step=0;
    this.markUn.alpha=0;
    this.imgCointainer.addChild(this.markObj);
    this.imgCointainer.addChild(this.markUn);
    this.imgCointainer.addChild(this.wrongObj);
    
    this.x=this.conf.pos[0];
    this.y=this.conf.pos[1];
    this.zIndex=this.conf.zIndex;
    
    this.objArr={};
    this.moveObj={dir:[0,0],step:0,step_max:0,pos_start:[0,0],};
    
    
}
dobbleGameCell.prototype = Object.create(myPixiElement.container.prototype);
dobbleGameCell.prototype= $.extend(dobbleGameCell.prototype,{
    
    init:function(){
        this.prepareView();
        
    },
    prepareView:function(){
        var i,bum;
        for(i in this.imgConf){
            bum=this.imgConf[i];
            this.objArr[bum.img_id]=new dobbleGameImg({ 
                    img_id:bum.img_id,
                    pos:[bum.x,bum.y],
                    scale:bum.scale,
                    angle_pi:bum.angle_pi
                },
                this.resources
            );
            this.imgCointainer.addChild(this.objArr[bum.img_id]);
        }
    },
    
    preparePoly:function(){
        if(this.polyIsSet){
            return false;
        }
        this.polyIsSet=1;
        var i,bum,size_base,size=[],cornersArr;
        for(i in this.imgConf){
            bum=this.imgConf[i];
            
            size_base=[
                this.resources["img"+bum.img_id].texture.baseTexture.width,
                this.resources["img"+bum.img_id].texture.baseTexture.height
            ];
            size[0]=bum.scale*size_base[0]/100;
            size[1]=bum.scale*size_base[1]/100;
            cornersArr=makeCorners(size);
            size[0]=size[0]/2;
            size[1]=size[1]/2;
            cornersArr=rotatePoints(cornersArr,bum.angle_pi);
            cornersArr=translatePoints(cornersArr,[bum.x,bum.y]);
            this.imgConf[i].poly=new PIXI.Polygon(copyArray(cornersArr));
        }
        return true;
    },
    checkClick:function(pos){
        var x=pos[0]-this.x,y=pos[1]-this.y;
        if(!this.mainCircle.contains(x,y)){
            return -1;
        }
        if(this.markObj.img_active!=-1){
            var obj=this.objArr[this.markObj.img_active];
            var vec=makeVector([obj.x,obj.y],[x,y]);
            if(lengthVectorPow(vec)<=this.markObj.r_cur2){
                return this.markObj.img_active;
            }
        }
        
        this.preparePoly();
        var i;
        for(i in this.imgConf){
            if(this.imgConf[i].poly.contains(x,y)){
                return this.imgConf[i].img_id;
            }
        }
        return -1;
    },
    haveImage:function(img_id){
        var i;
        for(i in this.imgConf){
            if(this.imgConf[i].img_id==img_id){
                return 1;
            }
        }
        return 0;
    },
    findCommon:function(obj){
        var i,k;
        for(i in this.imgConf){
            for(k in obj.imgConf){
                if(this.imgConf[i].img_id==obj.imgConf[k].img_id){
                    return this.imgConf[i].img_id;
                }
            }
        }
        return -1;
    },
    unableShow:function(img_id){
        
        var img=this.imgConf[img_id];
        
        var scale=Math.min(100,img.scale*1.1);
        
        this.markUn.x=img.x;
        this.markUn.y=img.y;
        this.markUn.scale.set(scale/100,scale/100);
        
        this.markUn.zIndex=-1;
        this.markUn.alpha=1;
        this.updateLayersOrder();
    },
    unableHide:function(){
        this.markUn.alpha=0;
    },
    unmarkImage:function(){
        if(typeof this.markObj=="undefined"){
            return false;
        }
        this.markObj.img_active=-1;
        this.markObj.alpha=0;
    },
    updateLine:function(){
        if(typeof this.lineCointainer.line_conf=="undefined"){
            return false;
        }
        
        var conf=this.lineCointainer.line_conf;
        var pos_end=[conf.pos_end[0]-this.x,conf.pos_end[1]-this.y];
       
        var len=lengthVector(pos_end);
        
        this.lineCointainer.line_obj.height=len;
        var deg_PI=Math.acos(pos_end[0]/len);
        if(pos_end[1]<0){
            deg_PI*=-1;
        }
        deg_PI+=Math.PI/2;
        this.lineCointainer.line_obj.rotation=deg_PI;
         
         
        
//        this.shapeArr["line"]
//        .clear()
//        .lineStyle(6,0x000000)
//        .moveTo(0, 0)
//        .lineTo(pos_end[0], pos_end[1])
//        .lineStyle(4,conf.color)
//        .moveTo(0, 0)
//        .lineTo(pos_end[0], pos_end[1]);

    },
    markLine:function(img_id,conf){
        
        var img=this.imgConf[img_id];
        
        this.shapeArr.line_circle.scale.set(
                Math.min(100,
                img.scale*1.1)/100
        );
        this.lineCointainer.x=img.x;
        this.lineCointainer.y=img.y;
        
        var pos_end=conf.pos;
        var i;
        for(i in this.objArr){
            this.objArr[i].zIndex=0;
        }
       
       
        ///prepare line
        
        
        
        var qTexture=new PIXI.Texture(PIXI.utils.TextureCache[conf.line_img]);
        if(typeof this.lineCointainer.line_obj!="undefined"){
            this.lineCointainer.line_obj.destroy();
        }
        
        this.lineCointainer.line_obj=new PIXI.TilingSprite ( qTexture, qTexture.baseTexture.width, 100);
        this.lineCointainer.line_obj.anchor.set(0.5,1);
//        this.lineCointainer.line_obj.alpha=0.6;
        this.shapeArr.line.addChild(this.lineCointainer.line_obj);
        
        this.objArr[img_id].zIndex=2;
        this.lineCointainer.zIndex=1;
        this.lineCointainer.line_conf={
            pos_end:[pos_end[0]-img.x,pos_end[1]-img.y],
            color:conf.color,
            pos_img:[this.lineCointainer.x,this.lineCointainer.y]
        };
        this.lineCointainer.alpha=1;
        this.updateLine();
        this.updateLayersOrder();
    },
    unMarkLine:function(){
        this.lineCointainer.alpha=0;
    },
    prepareCircle:function(obj,shape_obj,color,img_id){
        var img=this.imgConf[img_id];
        
        var size=Math.min(this.conf.img_size_full*img.scale/100*1.1,this.conf.img_size_full)/2;
        
        
        shape_obj
        .clear()
        .beginFill(color)
        .drawCircle(0, 0, size)
        .endFill()
        .lineStyle(1,0x000000)
        .drawCircle(0, 0, size)
        .endFill();
        
        
        obj.x=img.x;
        obj.y=img.y;
        obj.zIndex=-1;
        return img;
    },
    markImage:function(img_id){
//        this.prepareCircle(this.markObj,this.shapeArr["mark"],0xBFFF5E,img_id)
        
        var img=this.imgConf[img_id];
        
        var size=Math.min(this.conf.img_size_full*img.scale/100*1.1,this.conf.img_size_full)/2;
        var scale=Math.min(100,img.scale*1.1);
        
        
        this.markObj.x=img.x;
        this.markObj.y=img.y;
        this.markObj.zIndex=-2;
        this.markObj.scale.set(scale/100,scale/100);
        
        this.markObj.r_cur2=size*size;
        this.markObj.img_active=img_id;
        this.markObj.step=0;
        this.markObj.alpha=1;
        this.updateLayersOrder();
    },
    wrongImage:function(img_id){
        var img=this.imgConf[img_id];
        this.wrongObj.x=img.x;
        this.wrongObj.y=img.y;
        this.wrongObj.zIndex=3;
        
        this.wrongObj.alpha=1;
        this.updateLayersOrder();
        this.wrongObj.fadeOut(60);
    },
    
    debugArr:function(data){
        this.borderLine=new PIXI.Graphics();
        this.borderLine.alpha=1;
        this.addChild(this.borderLine);
        this.borderLine.clear();
        this.borderLine.lineStyle(1, 0x000000);
        
        var i,i_max=data.length;
        this.borderLine.moveTo(data[0],data[1]);
        
        for(i=2;i<i_max;i+=2){
            this.borderLine.lineTo(data[i],data[i+1]);
        }
        
        this.borderLine.endFill();
    },
    findAllCards:function(){
        var need_elements=this.conf.imgArr.length,have_elements=0;
        var imgReady,i,i_max;
        for(i=0,i_max=300;i<i_max && need_elements!=have_elements;i++){
            imgReady=this.findOneSolution();
            have_elements=imgReady.length;
        }
        if(need_elements==have_elements){
            $.qLog("<br>tak_"+i);
            var arr=[],bum;
            for(i in imgReady){
                bum=imgReady[i];
                arr.push({
                    x:bum.pos[0],y:bum.pos[1],
                    angle_pi:bum.angle_pi,
                    scale:bum.scale,img_id:bum.img_id
                });
            }
            var to_send={
                set_id:this.conf.set_id,
                arr_id:this.conf.arr_id,
                log_new:1,
                arr:arr
            };
            $.mypost("/other/calibdobble",to_send);
            
        }
        else{
            $.qLog("<br>nie:_"+this.conf.arr_id);
        }
        
        var bum;
        for(i in imgReady){
            bum=imgReady[i];
            this.imgCointainer.addChild(
                new dobbleGameImg({ 
                        img_id:bum.img_id,
                        pos:bum.pos,
                        scale:bum.scale,
                        angle_pi:bum.angle_pi
                    },
                    this.resources
                )
            );
        }
        console.log(imgReady);
    },
    findOneSolution:function(){
        var i_main,i,i_max,img_id;
        var size=[],size_base,scale,angle_pi;
        var qconf={
            "1":{scale_range:[70,100],easy:[5,6,8,9,18,19,21,22]},
            "2":{scale_range:[55,82],easy:[5,12]},
            "3":{scale_range:[50,75],easy:[1,7,50,52,3,12,21,31,35,11,13,15,16,26,41,42,44,51,56,57,19,20,47]}
        };
        
        
        var scale_range=copyArray(qconf[this.conf.set_id].scale_range);
        if(this.conf.set_id==1 && in_array(this.conf.arr_id,qconf[this.conf.set_id].easy)){
            scale_range=[65,90];
        }
        if(this.conf.set_id==2 && in_array(this.conf.arr_id,qconf[this.conf.set_id].easy)){
            scale_range=[53,80];
        }
        if(this.conf.set_id==3 && in_array(this.conf.arr_id,qconf[this.conf.set_id].easy)){
            scale_range=[47,66];
        }
        
        
        var cornersArr,checkArr;
        
        var cardsData=[];
        
        var test_id;
        
        
        
        for(i_main in this.conf.imgArr){
            img_id=this.conf.imgArr[i_main];
            size_base=[
                this.resources["img"+img_id].texture.baseTexture.width,
                this.resources["img"+img_id].texture.baseTexture.height
            ];
            
            var was_found=0;
            for(test_id=0;test_id<20 && !was_found;test_id++){//test rotation and scale
            
                
                scale=mt_rand(scale_range[0],scale_range[1]);
                angle_pi=mt_rand(1,360)/180*Math.PI;


    //            scale=100;
    //            angle_pi=30/180*Math.PI;

                size[0]=scale*size_base[0]/100;
                size[1]=scale*size_base[1]/100;
                cornersArr=makeCorners(size);
                size[0]=size[0]/2;
                size[1]=size[1]/2;
                
                checkArr=addCheckPoints(cornersArr,4);

                //rotation
                cornersArr=rotatePoints(cornersArr,angle_pi);
                checkArr=rotatePoints(checkArr,angle_pi);


                var dir_len=Math.round(this.conf.radius-Math.min(size[0],size[1])),pos;
                var cornersArr_t,checkArr_t,k;
                for(k=0;k<200;k++){//test translation
                    pos=[mt_rand(-dir_len,dir_len),mt_rand(-dir_len,dir_len)];
                    cornersArr_t=translatePoints(cornersArr,pos);
                    checkArr_t=translatePoints(checkArr,pos);
                    
                    var in_circle=1;
                    
                    for(i=0,i_max=cornersArr_t.length;i<i_max;i+=2){
                        if(!this.mainCircle.contains(cornersArr_t[i],cornersArr_t[i+1])){
                            in_circle=0;
                            break;//not in the main circle
                        }
                    }
                    if(in_circle){
                        var ready_id,poly;
                        var is_cosilion=0;
                        for(ready_id in cardsData){
                            poly=cardsData[ready_id].polygon;
                            for(i=0,i_max=checkArr_t.length;i<i_max;i+=2){
                                if(poly.contains(checkArr_t[i],checkArr_t[i+1])){
                                    is_cosilion=1;
                                    break;
                                }
                            }
                        }
                        if(!is_cosilion){
                            cardsData.push({
                                polygon:new PIXI.Polygon(copyArray(cornersArr_t)),
                                img_id:img_id,
                                pos:copyArray(pos),
                                scale:scale,
                                angle_pi:angle_pi
                            });
                            was_found=1;
                            break;
                        }
                    }
                   
                }
            }
            
        }
        return cardsData;
    },
    setZindex:function(zindex){
        this.zIndex=zindex;
    },
    moveToPos:function(pos_end,on_end){
        
        var pos_start=[this.x,this.y];
        var dir=makeVector(pos_start,pos_end);
        var step_max=lengthVector(dir)/this.conf.v;
        this.moveObj={
            dir:dir,
            step:0,
            step_max:step_max,
            pos_start:pos_start,
            onEnd:on_end
        };
    },
    updateLayersOrder:function () {
        this.imgCointainer.children.sort(function(a,b) {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    },
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        if(this.moveObj.step_max!=0){
            this.moveObj.step+=delta;
            var div=1;
            if(this.moveObj.step>=this.moveObj.step_max){
                this.moveObj.step=this.moveObj.step_max;
                this.moveObj.step_max=0;
            }
            else{
                div=this.moveObj.step/this.moveObj.step_max;
            }
            this.x=this.moveObj.dir[0]*div+this.moveObj.pos_start[0];
            this.y=this.moveObj.dir[1]*div+this.moveObj.pos_start[1];
            this.updateLine();
            if(this.moveObj.step_max==0){
                if(typeof this.moveObj.onEnd!="undefined"){
                    this.moveObj.onEnd.call(this);
                }
            }
        }
        if(this.markObj.img_active!=-1){
            
            this.markObj.step+=delta;
            var step_max=60;
            this.markObj.rotation=Math.PI*2*this.markObj.step%step_max;
//            if(this.markObj.step%step_max<step_max/2){
//                this.markObj.alpha=1;
//            }
//            else{
//                this.markObj.alpha=0;//0
//            }
//            
//            this.markObj.myUpdate(delta);
            
        }
        this.wrongObj.myUpdate(delta);
    }
});